module.exports = __webpack_public_path__ + "img/tijian_img3.10f3bd49.png";